import React from "react";
import Graph2 from "./elementary/Graph2";
import { usePartialWrapper } from "@client/components/wrappers/PartialWrapper";

type Chart2Props = {
  topicIds: string[];
  boolean?: boolean;
  className?: string;
};

const Chart2: React.FC<Chart2Props> = ({ topicIds, boolean = false, className = "" }) => {
  const { hidden, isFullscreen } = usePartialWrapper();

  return (
    <div
      style={{
        // Dvoustavová hodnota nepotřebuje výšku číselného grafu — schodová čára se
        // vejde do zlomku. Osa X sama zabírá 22 px (Graph2Render), takže na průběh
        // zbývá ~50 px, což na „zapnuto/vypnuto" stačí.
        height: isFullscreen ? undefined : boolean ? "72px" : `${topicIds.length * 30 + 300}px`,
      }}
      className={`${isFullscreen ? "flex grow" : ""} ${className}`}
    >
      <Graph2 className="min-h-0" topicIds={topicIds} boolean={boolean} hidden={hidden} isFullscreen={isFullscreen} />
    </div>
  );
};

export default React.memo(Chart2);
